module.exports = __webpack_public_path__ + "34320313.webp";